import React from 'react'
import { Typography } from '@mui/material'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import type { GetCommentButtonProps } from 'redesign/components/templates/task-details-action-buttons/types'

export const getCommentButton = ({
  sendEvent,
  refetch,
  setMessageDrawerProps,
  t,
  taskEvent,
  drawerProps = {},
  buttonProps = {},
  onSuccess,
}: GetCommentButtonProps) =>
  ({
    onClick: () =>
      setMessageDrawerProps({
        onClick: (comment) =>
          sendEvent(taskEvent, comment, () => {
            refetch()
            onSuccess?.()
          }),
        headerLabel: <Typography variant="subtitle1">{t('label.comment')}</Typography>,
        isRequired: true,
        commentFieldLabel: t('inputLabel.comment'),
        ...drawerProps,
      }),
    label: t('button.addComment'),
    testId: 'timeline-action-button_comment',
    ...buttonProps,
  } as Action)
